










































import { Component, Vue, Prop } from 'vue-property-decorator';
import GradientHexagon from '~/components/UIComponents/GradientHexagon.vue';

@Component({ components: { GradientHexagon } })
export default class InfoCard extends Vue {
  @Prop(String) readonly imgSrc!: string;
  @Prop(String) readonly content!: string;
  @Prop(String) readonly btnText!: string;
  @Prop(String) readonly uniqueId!: string;
  @Prop(String) readonly link!: string;
  @Prop(String) readonly route!: string;
  @Prop({ type: String, default: '100%' }) readonly btnWidth!: string;

  get btnStyle() {
    return {
      width: this.btnWidth,
    };
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
